import script from "./DocForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocForgotPassword.vue?vue&type=script&setup=true&lang=ts"

import "./DocForgotPassword.vue?vue&type=style&index=0&id=a5ecbd82&lang=css"

const __exports__ = script;

export default __exports__